import { render, staticRenderFns } from "./BaseSlideList.vue?vue&type=template&id=b6a83f7e&"
import script from "./BaseSlideList.vue?vue&type=script&lang=ts&"
export * from "./BaseSlideList.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSlideList.vue?vue&type=style&index=0&id=b6a83f7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports